<app-funnel-shell>
  <div class="funnel-card">
    @switch (phase()) {

      @case ('opening') {
        <h1>{{ 'funnel.join_start.title' | translate }}</h1>
        <p class="funnel-card__intro">{{ 'funnel.join_start.loading' | translate }}</p>
      }

      @case ('password') {
        <h1>{{ 'funnel.join_start.password_title' | translate }}</h1>
        <p class="funnel-card__intro">{{ 'funnel.join_start.password_intro' | translate }}</p>

        <form (ngSubmit)="submitPassword()" novalidate>
          <label class="d-block mb-3">
            <span class="d-block mb-1">{{ 'funnel.join_start.password_label' | translate }}</span>
            <input
              class="form-control"
              type="password"
              name="password"
              autocomplete="new-password"
              [(ngModel)]="password"
              (ngModelChange)="onPasswordInput()"
              required
            />
          </label>

          <label class="d-block mb-3">
            <span class="d-block mb-1">{{ 'funnel.join_start.password_confirm_label' | translate }}</span>
            <input
              class="form-control"
              type="password"
              name="password_confirmation"
              autocomplete="new-password"
              [(ngModel)]="passwordConfirmation"
              (ngModelChange)="onPasswordInput()"
              required
            />
          </label>

          <p class="funnel-card__footnote">
            {{ 'funnel.join_start.password_hint' | translate:{ min: minLength } }}
          </p>

          <button cButton color="primary" type="submit" class="w-100" [disabled]="!passwordValid() || busy()">
            @if (busy()) {
              {{ 'funnel.join_start.password_saving' | translate }}
            } @else {
              {{ 'funnel.join_start.password_submit' | translate }}
            }
          </button>

          @if (error(); as message) {
            <div class="alert alert-danger mt-3" role="alert">{{ message }}</div>
          }
        </form>
      }

      @case ('signing_in') {
        <h1>{{ 'funnel.join_start.signing_in_title' | translate }}</h1>
        <p class="funnel-card__intro">{{ 'funnel.join_start.signing_in' | translate }}</p>
      }

      @case ('error') {
        <h1>{{ 'funnel.join_start.error_title' | translate }}</h1>
        <p class="funnel-card__intro">{{ error() }}</p>
      }
    }
  </div>
</app-funnel-shell>
